import script from "./ProjectVideoListChrome.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectVideoListChrome.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectVideoListChrome.vue?vue&type=style&index=0&id=574378b1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-574378b1"]])

export default __exports__